import { useCallback } from 'react';
import { useStore } from 'react-redux';

import { ApiABExperimentId } from 'api/types/ApiABExperiment';
import { setABExperimentBucket } from 'modules/main/store/ducks/userEnvironment';

/**
 * The backend doesn't necessarily send back the experiment id in the result,
 * and we might use the same hook in multiple places.
 *
 * To avoid making the same request multiple times we check if we've already
 * requested to set this value
 */
const AB_EXPERIMENT_BUCKETS_SET: Record<string, boolean> = {};

export function useSetABExperimentBucket(id: ApiABExperimentId) {
  const { dispatch, getState } = useStore();

  return useCallback(() => {
    if (!AB_EXPERIMENT_BUCKETS_SET[id]) {
      AB_EXPERIMENT_BUCKETS_SET[id] = true;

      const dispatchSetBucket = setABExperimentBucket(id);
      // @ts-expect-error TS(2345): Argument of type '() => unknown' is not assignable... Remove this comment to see the full error message
      dispatchSetBucket(dispatch, getState);
    }
  }, [dispatch, getState, id]);
}
